import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("olime_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
